import { LitElement, html, css, styleMap } from '@hh/global.js'

class HHMainBlog extends LitElement {
  static get properties() {
    return {
      dates: { type: Array },
      blogs: { type: Array },
      articles: { type: Array },
      array: { type: Array },
      blogsLimit: { type: Number },
      currentPage: { type: Number },
      bHandle: {
        attribute: 'b-handle',
        type: String,
      },
      pbVerb: {
        attribute: 'pb-verb',
        type: String,
      },
      pbSeparator: {
        attribute: 'pb-separator',
        type: String,
      },
    }
  }

  constructor() {
    super()
    this.dates = []
    this.blogs = []
    this.articles = []
    this.array = []
    this.currentPage = 1
  }

  connectedCallback() {
    super.connectedCallback()
    this.fetchData(this.bHandle)
  }

  async fetchData(handle) {
    const query = `
    query {
      blogs(first: 100) {
        edges {
          node {
            title
            handle
            articles(first: 100) {
              edges {
                node {
                  title
                }
              }
            }
          }
        }
      }
      blogByHandle(handle: "${handle}") {
        id
        title
        handle
        articles(first: 100) {
          edges {
            node {
            id
            title
            handle
            onlineStoreUrl
            image {
                url
            }
            ... on Article {
                handle
                title
                blog {
                title
                }
              }
            }
          }
        }
      }
    }
    `

    const fetchData = async () => {
      const response = await fetch(
        `https://${window.Shopify.shop}/api/2023-01/graphql`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token':
              '84e74b5b26ea9ce0d6cdd95337c47878',
          },
          body: JSON.stringify({ query }),
        }
      )

      const { data } = await response.json()

      return data
    }

    this.dates = await fetchData()

    this.blogs = this.dates.blogs.edges.map((edge) => edge.node)

    this.articles = this.dates.blogByHandle.articles.edges.map(
      (edge) => edge.node
    )

    for (let i = 0; i < this.articles.length; i++) {
      this.array = this.array.concat(this.articles[i])
    }

    if (this.blogsLimit >= this.array.length) {
      this.shadowRoot.querySelector('.blog-list__progress-bar').remove()
    } else {
      this.shadowRoot
        .querySelector('.blog-list__progress-bar')
        .classList.remove('is-hidden')
    }
  }

  _update() {
    this.blogsLimit = this.blogsLimit + this.blogsLimit
    if (this.blogsLimit >= this.array.length) {
      this.shadowRoot.querySelector('.blog-list__progress-bar').remove()
    }
  }

  render() {
    const startIndex = (this.currentPage - 1) * this.blogsLimit
    const endIndex = startIndex + this.blogsLimit
    const articlesToShow = this.array.slice(startIndex, endIndex)
    const progressBar =
      Math.round((this.blogsLimit / this.array.length) * 100) + '%'

    return html`
      <div class="blog-list__container">
        ${articlesToShow.map(
          (article) => html`
            <article class="article-card">
              <a
                href="${article.onlineStoreUrl}"
                class="article-content motion-reduce"
              >
                <div class="article-card__image-wrapper">
                  <div class="article-card__image media">
                    <img
                      src="${article.image.url}"
                      loading="lazy"
                      class="motion-reduce"
                    />
                  </div>
                  <div class="article-card__category">
                    <span class="article-card__category-name"
                      >${article.blog.title}</span
                    >
                  </div>
                </div>
                <div class="article-card__info">
                  <header class="article-card__header">
                    <h6 class="article-card__title">${article.title}</h6>
                  </header>
                </div>
              </a>
            </article>
          `
        )}
      </div>
      <div class="blog-list__progress-bar is-hidden">
        <div class="blog-list__progress-bar__header">
          <span class="blog-list__progress-bar__heading"
            >${this.pbVerb}&nbsp;${this.blogsLimit}&nbsp;${this
              .pbSeparator}&nbsp;${this.array.length}</span
          >
        </div>
        <span class="progress-bar__inner-wrapper">
          <span
            class="progress-bar__inner"
            style=${styleMap({ width: progressBar })}
          ></span>
        </span>
        <div class="blog-list__progress-load">
          <slot name="trigger" @click=${this._update}></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    a {
      font: var(--hh-font-body);
      color: var(--hh-color-text);
      text-decoration: none;
    }
    ul {
      list-style: none;
      margin: 0;
    }
    .media {
      display: block;
      background: var(--hh-color-light);
      position: relative;
      overflow: hidden;
    }
    .media > img:not(.zoom) {
      width: 100%;
      max-width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
      object-position: center center;
      transition: opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
    .is-hidden {
      display: none;
    }
    .blog-categories {
      margin: 3.8rem 0 4.4rem;
    }
    @media screen and (min-width: 990px) {
      .blog-categories {
        margin: 7.7rem 0 5.9rem;
      }
    }
    .blog-categories-wrapper {
      padding-left: 1rem;
    }
    .blog-categories-list {
      display: flex;
      column-gap: 1rem;
      padding-right: 1rem;
      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .blog-categories-list::-webkit-scrollbar {
      display: none;
    }
    @media screen and (min-width: 990px) {
      .blog-categories-list {
        justify-content: center;
      }
    }
    .blog-category {
      font: var(--hh-body-utility);
      text-transform: uppercase;
      letter-spacing: 0.1em;
      user-select: none;
      border: 0.1rem solid var(--hh-color-foreground);
      cursor: pointer;
      transition: background-color var(--hh-duration-default) ease-in-out;
    }
    .blog-category > a {
      display: block;
      padding: 0.6rem 0.9rem;
    }
    .blog-category:hover,
    .blog-category.active {
      color: var(--hh-color-background);
      background-color: var(--hh-color-foreground);
    }
    .blog-category:hover a {
      color: var(--hh-color-background);
    }
    .blog-list__container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.7rem 1.2rem;
      margin-bottom: 6.6rem;
    }
    @media screen and (min-width: 990px) {
      .blog-list__container {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 3.8rem 1.2rem;
      }
    }
    @media screen and (min-width: 1280px) {
      .blog-list__container {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }
    .article-card__image-wrapper {
      position: relative;
    }
    .article-card__image {
      min-height: 23rem;
    }
    @media screen and (min-width: 990px) {
      .article-card__image {
        min-height: 46.4rem;
      }
    }
    .article-card__category {
      position: absolute;
      bottom: 0.8rem;
      left: 1rem;
      padding: 0.4rem 1rem;
      background: var(--hh-color-night);
    }
    @media screen and (min-width: 990px) {
      .article-card__category {
        bottom: 1.1rem;
      }
    }
    .article-card__category-name {
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: var(--hh-color-day);
    }
    .article-card__info {
      margin-top: 1.2rem;
    }
    @media screen and (min-width: 990px) {
      .article-card__info {
        margin-top: 1rem;
      }
    }
    .article-card__title {
      font: var(--hh-h6-font);
      text-transform: var(--hh-h6-text-transform);
      letter-spacing: var(--hh-h6-letter-spacing);
      margin: 0;
    }
    .blog-list__progress-bar {
      text-align: center;
    }
    .blog-list__progress-bar__header {
      margin-bottom: 0.7rem;
    }
    .blog-list__progress-bar__heading {
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
    .progress-bar__inner-wrapper {
      display: block;
      position: relative;
      width: 100%;
      max-width: 20rem;
      height: 0.2rem;
      background: var(--hh-color-brand-tertiary);
      margin: 0 auto;
    }
    .progress-bar__inner {
      display: block;
      position: absolute;
      inset: 0px;
      background: var(--hh-color-foreground);
    }
    .blog-list__progress-load {
      margin-top: 3.1rem;
    }
  `
}

customElements.define('hh-main-blog', HHMainBlog)
